export default [
    {
        id: 1,
        tittel: "alternativer.feilopplysninger.tittel",
        melding: "alternativer.feilopplysninger.melding",
    },
    {
        id: 2,
        tittel: "alternativer.savneropplysninger.tittel",
        melding: "alternativer.savneropplysninger.melding",
    },
    {
        id: 3,
        tittel: "alternativer.utlevere.tittel",
        melding: "alternativer.utlevere.melding",
    },
    {
        id: 4,
        tittel: "alternativer.klage.tittel",
        melding: "alternativer.klage.melding",
    },
];
